import choose_bg from "../images/choose_bg.png";

const ChooseUsSection = () => {
  return (
    <section
      className="py-40 md:px-40 bg-cover bg-center min-h-screen"
      style={{ backgroundImage: `url(${choose_bg})` }}
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-semibold text-left mb-8 text-white ml-6">
          <span className="text-7xl text-[#FF5733] font-bold">Why</span> Choose
          Us: <br />
          Promote Ethical Business Practice
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* First Column */}
          <div className="p-6">
            <h3 className="text-2xl font-semibold mb-4 text-center bg-[#004E98] p-6 rounded text-white">
              Make a Difference
            </h3>
            <p className="text-white font-inter font-light">
              By supporting our anti-corruption organization, your company
              promotes ethical business practices.
            </p>
          </div>

          {/* Second Column */}
          <div className="p-6">
            <h3 className="text-2xl font-semibold mb-4 text-center bg-[#004E98] p-6 rounded text-white">
              Build Trust
            </h3>
            <p className="text-white font-inter font-light">
              Consumers value businesses that take a stand for ethical
              practices. Supporting our cause will build your reputation as a
              leader in social responsibility.
            </p>
          </div>
        </div>

        {/* Single Column Below */}
        <div className="mt-8 ml-6 mr-6">
          <h3 className="text-2xl font-semibold mb-4 text-center bg-[#004E98] p-6 rounded text-white">
            No Scrutiny, Just Impact
          </h3>
          <p className="text-white font-inter text-center font-light">
            Unlike focusing on scrutinizing ethics, we highlight the positive
            change your company is helping create.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ChooseUsSection;
